import { Button } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'store/store';
import { setIsOpenNoDeleteAccess } from 'store/user-service/userSlice';

import { NamespacesList } from 'core/enums/common';

import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Error } from 'assets/icons/error.svg';

export const NoDeleteAccessModal = () => {
	const { t: modalsTranslate } = useTranslation(NamespacesList['modals']);

	const dispatch = useAppDispatch();
	const [open, setOpen] = useState<boolean>(true);

	const handleClose = () => {
		dispatch(setIsOpenNoDeleteAccess(false));
		setOpen(false);
	};

	return (
		<InfoModal
			isOpen={open}
			onClose={handleClose}
			image={<Error />}
			title={modalsTranslate('noDeleteAccess.title')}
			description={modalsTranslate('noDeleteAccess.description')}
			buttons={
				<Button
					className="not-rtl-able"
					sx={{
						height: '44px',
						width: { xs: '90%', sm: '100%' },
						borderRadius: '8px',
						textTransform: 'none',
						fontSize: '16px',
						fontWeight: '700',
						marginTop: '24px',
					}}
					variant="contained"
					color="primary"
					onClick={handleClose}
				>
					{modalsTranslate('noDeleteAccess.close')}
				</Button>
			}
		></InfoModal>
	);
};
